import { useEffect, useState } from "react";
import banner1 from "../../assets/home/prperty/zpage.png";
import detail from "../../assets/home/prperty/details1.png";
import detail1 from "../../assets/home/prperty/details2.png";
import amb from "../../assets/home/prperty/details2.png";
import amb1 from "../../assets/home/prperty//amb2.png";
import banner2 from "../../assets/home/prperty/detailbg.png";
import { Navbar } from "../../Component/Navbar";
import { Footer } from "../../Component/Footer";
import { Link, Navigate, useNavigate } from "react-router-dom";

export default function Properties() {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredServices, setFilteredServices] = useState([]);
  const servicesPerPage = 6;

  const [transport, setTransport] = useState([]);
  const [filteredTransport, setFilteredTransport] = useState([]);
  const [searchQuery2, setSearchQuery2] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const transportPerPage = 6;
  const [selectedCategory, setSelectedCategory] = useState("Choose");
  const [selectedLocation, setSelectedLocation] = useState("Choose");
  const [selectedPrice, setSelectedPrice] = useState("Choose");
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // ================== Services api integration =================
  useEffect(() => {
    setIsLoading(true);
    fetch(
      "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/service-form/get-alluser"
    )
      .then((response) => response.json())
      .then((data) => {
        setServices(data.serviceFormData);
        setFilteredServices(data.serviceFormData);
      })
      .catch((error) => console.error("Error fetching services:", error));
    setIsLoading(false);
  }, []);

  // Handle search functionality
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = services.filter((service) =>
      service.serviceDetails.address1.toLowerCase().includes(query)
    );
    setFilteredServices(filtered);
    setCurrentPage(1); // Reset to the first page
  };

  // Pagination calculations
  const totalPages = Math.ceil(filteredServices.length / servicesPerPage);
  const paginatedServices = filteredServices.slice(
    (currentPage - 1) * servicesPerPage,
    currentPage * servicesPerPage
  );

  // Fetch transportation data
  useEffect(() => {
    setIsLoading(true);
    fetch(
      "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/transport-form/get-alluser"
    )
      .then((response) => response.json())
      .then((data) => {
        setTransport(data.transportFormData);
        setFilteredTransport(data.transportFormData);
      })

      .catch((error) => console.error("Error fetching transportation:", error));
    setIsLoading(false);
  }, []);

  // Handle search functionality
  const handleSearch2 = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery2(query);

    const filtered = transport.filter((item) =>
      item.vehicleDetails.name.toLowerCase().includes(query)
    );
    setFilteredTransport(filtered);
    setCurrentPage2(1); // Reset to the first page
  };

  //  pagination feature TRANSPORT
  const totalPages2 = Math.ceil(filteredTransport.length / transportPerPage);
  const paginatedTransport = filteredTransport.slice(
    (currentPage2 - 1) * transportPerPage,
    currentPage2 * transportPerPage
  );

  // pagination features
  const handleServicePageChange = (page) => setCurrentPage(page);
  const handleTransportPageChange = (page) => setCurrentPage2(page);

  const handleServiceNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const handleServicePrevious = () =>
    setCurrentPage((prev) => Math.max(prev - 1, 1));

  const handleTransportNext = () =>
    setCurrentPage2((prev) => Math.min(prev + 1, totalPages2));
  const handleTransportPrevious = () =>
    setCurrentPage2((prev) => Math.max(prev - 1, 1));

  // ========= Adding Filters ========

  useEffect(() => {
    // Fetch locations from the general services API
    setIsLoading(true);
    fetch(
      "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/service-form/get-alluser"
    )
      .then((response) => response.json())
      .then((data) => {
        const generalServiceLocations = data.serviceFormData.map(
          (service) => service.serviceDetails.address1
        );

        // Fetch locations from the transport API
        fetch(
          "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/transport-form/get-alluser"
        )
          .then((response) => response.json())
          .then((data) => {
            const transportLocations = data.transportFormData.map(
              (transport) => transport.vehicleDetails.pickUpLocation
            );
            setIsLoading(false);

            // Combine and deduplicate locations
            const allLocations = [
              ...new Set([...generalServiceLocations, ...transportLocations]),
            ];
            setLocations(allLocations);
          })

          .catch((error) =>
            console.error("Error fetching transport locations:", error)
          );
      })

      .catch((error) =>
        console.error("Error fetching general service locations:", error)
      );
  }, []);

  const applyFilters = () => {
    let filteredServicesData = services;
    let filteredTransportData = transport;

    // Filter general services by location
    if (selectedLocation !== "Choose") {
      filteredServicesData = filteredServicesData.filter(
        (service) => service.serviceDetails.address1 === selectedLocation
      );
    }

    // Filter transport services by location
    if (selectedLocation !== "Choose") {
      filteredTransportData = filteredTransportData.filter(
        (transport) =>
          transport.vehicleDetails.pickUpLocation === selectedLocation
      );
    }

    // Filter by price (applies to both general and transport services)
    if (selectedPrice !== "Choose") {
      if (selectedPrice === "Sort by ascending") {
        filteredServicesData.sort(
          (a, b) => a.serviceDetails.phone - b.serviceDetails.phone
        );
        filteredTransportData.sort(
          (a, b) => a.vehicleDetails.phone - b.vehicleDetails.phone
        );
      } else if (selectedPrice === "Sort by descending") {
        filteredServicesData.sort(
          (a, b) => b.serviceDetails.phone - a.serviceDetails.phone
        );
        filteredTransportData.sort(
          (a, b) => b.vehicleDetails.phone - a.vehicleDetails.phone
        );
      }
    }

    // Update filtered data
    setFilteredServices(filteredServicesData);
    setFilteredTransport(filteredTransportData);
    setCurrentPage(1); // Reset to the first page
    setCurrentPage2(1); // Reset to the first page
  };
  const resetFilters = () => {
    setSelectedCategory("Choose");
    setSelectedLocation("Choose");
    setSelectedPrice("Choose");
    setFilteredServices(services); // Reset to all services
    setFilteredTransport(transport); // Reset to all transport
    setCurrentPage(1); // Reset to the first page
    setCurrentPage2(1); // Reset to the first page
  };

  return (
    <div>
      {/* Hero Section */}
      <Navbar />
      <div
        className="relative flex items-center mt-8 justify-center bg-cover   bg-center bg-purple-600 opacity-90 w-[91vw] h-96 rounded-lg px-8 mx-auto"
        style={{ backgroundImage: `url(${banner1})` }}
      >
        <div className="absolute rounded-lg inset-0 bg-gradient-to-r from-purple-600 to-transparent opacity-60"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-white">
          <h1 className="text-7xl font-bold">General Services</h1>
          <div className="mt-4 flex items-center gap-3">
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearch}
              placeholder="Search for Services"
              className="px-6 py-3 rounded-full text-black w-[50vw] shadow-lg focus:outline-none"
            />
          </div>
        </div>
      </div>

      <div className="flex flex-wrap p-8 ml-5">
        {/* Sidebar Filters */}
        <div className="w-full md:w-1/4 p-4">
          <div className="p-6 bg-white shadow-lg rounded-lg">
            <h2 className="text-xl font-bold mb-4">Filters</h2>
            <div className="mb-4">
              <label className="block text-gray-700">Filter by Category</label>
              <select
                className="w-full p-2 border rounded"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                <option>Choose</option>
                <option>General Service</option>
                <option>Transport Service</option>
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Filter by Location</label>
              <select
                className="w-full p-2 border rounded"
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
              >
                <option>Choose</option>
                {locations.map((location, index) => (
                  <option key={index}>{location}</option>
                ))}
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Filter by Price</label>
              <select
                className="w-full p-2 border rounded"
                value={selectedPrice}
                onChange={(e) => setSelectedPrice(e.target.value)}
              >
                <option>Choose</option>
                <option>Sort by ascending</option>
                <option>Sort by descending</option>
              </select>
            </div>
            <div className="flex space-x-2">
              <button
                className="w-full p-3 text-violet-700 border-2 border-purple-800 rounded-lg"
                onClick={resetFilters}
              >
                Reset
              </button>
              <button
                className="w-full p-3 bg-purple-600 text-white rounded-lg"
                onClick={applyFilters}
              >
                Apply
              </button>
            </div>
          </div>
        </div>

        {/* Service Cards */}

        <div className="w-full md:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {isLoading ? (
            <div className="flex justify-center items-center">
              <p className="text-2xl font-bold">Loading...</p>
            </div>
          ) : (
            <>
              {paginatedServices.map((service) => (
                <div
                  key={service._id}
                  className="bg-white shadow-lg rounded-lg overflow-hidden w-[20vw]"
                >
                  <img
                    src={service.uploadFiles?.[0]}
                    alt={service.serviceDetails.companyName}
                    className="w-full h-40 object-cover"
                  />
                  <div className="p-4">
                    <h3 className="text-lg font-bold capitalize">
                      {service.serviceDetails.address1}
                    </h3>
                    <p className="text-gray-500">
                      {service.serviceDetails.address2}
                    </p>
                    <p className="text-green-400" style={{ fontSize: "24px" }}>
                      ${service.serviceDetails.phone}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-yellow-400">★ ★ ★ ★ ★</span>
                      <p className="items-end justify-end text-slate-600">
                        {service.serviceDetails.industry1}
                      </p>
                    </div>
                    <div className="flex items-center justify-center mt-4">
                      <Link to={`/cardiac/${service._id}`} state={service}>
                        <button className="px-4 py-2 bg-purple-600 text-white rounded-lg">
                          Book Now
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>

      {/* Pagination */}
      <div className="flex justify-center mb-32 space-x-4 mt-6">
        <button
          onClick={handleServicePrevious}
          disabled={currentPage === 1}
          className={`px-4 py-2 rounded ${
            currentPage === 1
              ? "bg-gray-300 text-gray-600"
              : "bg-purple-600 text-white"
          }`}
        >
          Previous
        </button>
        {Array.from({ length: totalPages }, (_, index) => index + 1).map(
          (page) => (
            <button
              key={page}
              onClick={() => handleServicePageChange(page)}
              className={`px-4 py-2 rounded ${
                page === currentPage
                  ? "bg-purple-600 text-white"
                  : "bg-gray-200 text-black"
              }`}
            >
              {page}
            </button>
          )
        )}
        <button
          onClick={handleServiceNext}
          disabled={currentPage === totalPages}
          className={`px-4 py-2 rounded ${
            currentPage === totalPages
              ? "bg-gray-300 text-gray-600"
              : "bg-purple-600 text-white"
          }`}
        >
          Next
        </button>
      </div>

      <div
        className="relative flex items-center justify-center bg-cover bg-center bg-purple-600 w-[91vw] h-96    rounded-lg px-8 mx-auto"
        style={{ backgroundImage: `url(${banner2})` }}
      >
        <div className="absolute rounded-lg inset-0 bg-gradient-to-r from-black to-transparent opacity-60"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-white">
          <h1 className="text-6xl font-bold">Transportation Services</h1>
          <div className="mt-4">
            <input
              type="text"
              value={searchQuery2}
              onChange={handleSearch2}
              placeholder="Search for Services"
              className="px-6 py-3 rounded-full text-black w-[50vw] shadow-lg focus:outline-none"
            />
          </div>
        </div>
      </div>

      <div className="flex  flex-wrap p-8 ml-5">
        {/* Sidebar Filters */}
        <div className="w-full md:w-1/4 p-4">
          <div className="p-6 bg-white shadow-lg rounded-lg">
            <h2 className="text-xl font-bold mb-4">Filters</h2>
            <div className="mb-4">
              <label className="block text-gray-700">Filter by Category</label>
              <select
                className="w-full p-2 border rounded"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                <option>Choose</option>
                <option>General Service</option>
                <option>Transport Service</option>
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Filter by Location</label>
              <select
                className="w-full p-2 border rounded"
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
              >
                <option>Choose</option>
                {locations.map((location, index) => (
                  <option key={index}>{location}</option>
                ))}
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Filter by Price</label>
              <select
                className="w-full p-2 border rounded"
                value={selectedPrice}
                onChange={(e) => setSelectedPrice(e.target.value)}
              >
                <option>Choose</option>
                <option>Sort by ascending</option>
                <option>Sort by descending</option>
              </select>
            </div>
            <div className="flex space-x-2">
              <button
                className="w-full p-3 text-violet-700 border-2 border-purple-800 rounded-lg"
                onClick={resetFilters}
              >
                Reset
              </button>
              <button
                className="w-full p-3 bg-purple-600 text-white rounded-lg"
                onClick={applyFilters}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
        {/* Service Cards */}
        <div className="w-full md:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {paginatedTransport.map((transport) => (
            <div
              key={transport._id}
              className="bg-white shadow-lg rounded-lg overflow-hidden"
            >
              <img
                src={transport.uploadFiles?.[0]}
                alt={transport.vehicleDetails.name}
                className="w-full h-40 object-cover"
              />
              <div className="p-4">
                <h3 className="text-lg font-bold">
                  {transport.vehicleDetails.name}
                </h3>
                <p className="text-gray-500">
                  {transport.vehicleDetails.pickUpLocation}
                </p>
                <p className="text-green-400" style={{ fontSize: "24px" }}>
                  ${transport.vehicleDetails.phone}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-yellow-400">⭐⭐⭐⭐⭐</span>
                  <p className="items-end justify-end text-slate-600">
                    {transport.vehicleDetails.dropOffLocation}
                  </p>
                </div>
                <div className="flex items-center justify-center mt-4">
                  <Link to={`/travel/${transport._id}`} state={transport}>
                    <button className="px-4 py-2 bg-purple-600 text-white rounded-lg">
                      Book Now
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Pagination */}
      <div className="flex justify-center mb-10 space-x-4 mt-6">
        <button
          onClick={handleTransportPrevious}
          disabled={currentPage2 === 1}
          className={`px-4 py-2 rounded ${
            currentPage2 === 1
              ? "bg-gray-300 text-gray-600"
              : "bg-purple-600 text-white"
          }`}
        >
          Previous
        </button>
        {Array.from({ length: totalPages2 }, (_, index) => index + 1).map(
          (page) => (
            <button
              key={page}
              onClick={() => handleTransportPageChange(page)}
              className={`px-4 py-2 rounded ${
                page === currentPage2
                  ? "bg-purple-600 text-white"
                  : "bg-gray-200 text-black"
              }`}
            >
              {page}
            </button>
          )
        )}
        <button
          onClick={handleTransportNext}
          disabled={currentPage2 === totalPages2}
          className={`px-4 py-2 rounded ${
            currentPage2 === totalPages2
              ? "bg-gray-300 text-gray-600"
              : "bg-purple-600 text-white"
          }`}
        >
          Next
        </button>
      </div>
      <Footer />
    </div>
  );
}
